import moment from "moment";

export default function Footer(){
    return(
        <footer className="main-footer">
            <div className="float-right d-none d-sm-inline">
                LebenRaffle v1.01
            </div>
            <strong>Copyright &copy; {moment().format('YYYY')} <a href="https://www.grupoleben.com/">Grupo Leben Servicios de Marketing, S.L.</a>.</strong>
        </footer>
    );
}